import 'leaflet-editable';
import {
  DivIcon,
  Editable,
  Point,
  SVG, DomUtil
} from 'leaflet';

export const DotIcon = DivIcon.extend({
  options: {
    className: 'leaflet-dot-icon'
  }
});

export const mapMarkerIconPin = new DivIcon({
  html: `<svg width="32" height="32"
        xmlns="http://www.w3.org/2000/svg">
        <g fill-rule="nonzero">
          <path d="M16 4a10 10 0 0110 10c0 3.6-2.35 8.04-6.93 13.51a4 4 0 01-5.81.34l-.16-.16-.17-.18-.33-.4C8.23 21.8 6 17.5 6 14A10 10 0 0116 4z" fill-opacity=".2" fill="#000"/>
          <path d="M16 6a8 8 0 00-8 8c0 2.85 1.94 6.66 5.81 11.43l.33.4.33.4.1.12a2 2 0 001.5.6l.16-.02a2 2 0 001.3-.7C21.84 21.08 24 17 24 14a8 8 0 00-8-8z" fill="#29a7f4" />
          <path d="M16 5a9 9 0 019 9c0 3.3-2.25 7.56-6.7 12.87a3 3 0 01-4.32.29l-.14-.14-.14-.15-.33-.4C9.14 21.35 7 17.22 7 14a9 9 0 019-9zm0 1a8 8 0 00-8 8c0 2.85 1.94 6.66 5.81 11.43l.33.4.33.4.1.12a2 2 0 001.5.6l.16-.02a2 2 0 001.3-.7C21.84 21.08 24 17 24 14a8 8 0 00-8-8zm0 4a4 4 0 110 8 4 4 0 010-8z" fill="#FFF"/>
        </g>
      </svg>`,
  iconSize: [32, 32],
  iconAnchor: [16, 26],
  className: 'map-point'
});

export const POLYGON_OPTIONS = {
  fillColor: 'rgb(121, 191, 169)',
  fillOpacity: 0.36,
  stroke: true,
  weight: 2,
  color: '#71f6cc'
};

Editable.VertexIcon = DivIcon.extend({
  options: {
    iconSize: new Point(12, 12)
  }
});

Editable.TouchVertexIcon = Editable.VertexIcon.extend({});

Editable.MiddleMarkerIcon = Editable.VertexIcon.extend({
  options: {
    iconSize: new Point(8, 8)
  }
});

delete Editable.MiddleMarker.prototype.options.opacity;

Editable.prototype.originalCreateVertexIcon = Editable.prototype.createVertexIcon;
Editable.prototype.createVertexIcon = function (options) {
  if (options && options.className && options.className.includes('middle')) {
    return new Editable.MiddleMarkerIcon(options);
  } else {
    return this.originalCreateVertexIcon(options);
  }
};

SVG.prototype.original_updateStyle = SVG.prototype._updateStyle;
SVG.prototype._updateStyle = function (layer) {
  this.original_updateStyle(layer);
  let path = layer._path;
  if (!path) return;

  if (layer.options.stroke === null) {
    path.removeAttribute('stroke');
    path.removeAttribute('stroke-opacity');
    path.removeAttribute('stroke-width');
  }

  if (layer.options.fill === null) {
    path.removeAttribute('fill');
    path.removeAttribute('fill-opacity');
  }

  path.setAttribute('class', '');
  if (layer.options.className) {
    DomUtil.addClass(path, layer.options.className);
  }

  if (layer.options.interactive) {
    DomUtil.addClass(path, 'leaflet-interactive');
  }
};

export const DEFAULT_POINT_ZOOM = 17;

export const ARCGIS_BASE_URL = 'https://arcgis-proxy.eaimms.com';

export const MAXIMUM_MARKERS = 1000;
export const MINIMUM_MARKER_DISTANCE_METERS = 2;
export const CMP_BY_ZINDEX = (a, b) => a.zIndexOffset - b.zIndexOffset;
